import cx from 'classnames';
import React from 'react';
import styles from './FaqButtonAccordionIcon.module.scss';

interface IFaqButtonAccordionIcon extends React.AllHTMLAttributes<HTMLSpanElement> {
  open: boolean;
  variant: boolean;
}

export const FaqButtonAccordionIcon: React.FC<IFaqButtonAccordionIcon> = ({ open, variant }) => (
  <div className={cx(styles.accordionIcon, { [styles.open]: open, [styles.variant]: variant })}>
    {!variant && (
      <>
        <span className={styles.horizontalLine} />
        <span className={styles.verticalLine} />
      </>
    )}
    {variant && <span className={styles.arrowIcon} />}
  </div>
);

FaqButtonAccordionIcon.displayName = 'FaqButtonAccordionIcon';
